import React, { useState, useEffect } from "react";
import classes from "../styles/style.module.css";
import HuubleCard from "./HuubleCard";
import AwardsDialog from "./AwardsDialog";
import { useNavigate } from "react-router-dom";
import IntroduceDialog from "./IntroduceDialog";
import RegulationDialog from "./RegulationDialog";
import { isReferee } from "../../../assets/services/apiServices";
import Loading from "../../../assets/containers/loadingDialog";

const HubbleDashboardMenu = () => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [menuItems, setMenuItems] = useState([
    {
      icon: "/images/hubble/icons/menu.svg",
      text: "رشته ها",
      route: "/hubble/majors",
    },
    {
      icon: "/images/hubble/icons/profile-2user.svg",
      text: "معرفی",
      dialog: "introduce",
    },
    {
      icon: "/images/hubble/icons/document-normal.svg",
      text: "آیین‌نامه",
      dialog: "requlation",
    },
    {
      icon: "/images/hubble/icons/award.svg",
      text: "توضیحات",
      dialog: "awards",
    },
    {
      icon: "/images/hubble/icons/document-text.svg",
      text: "اخبار",
      route: "/hubble/blog",
    },
    {
      icon: "/images/hubble/icons/user-tag.png",
      text: "اثرهای من",
      route: "/hubble/myUploads",
    },
    {
      icon: "/images/hubble/icons/convert.svg",
      text: "آموزش فشرده سازی",
      route: "/hubble/compressEd",
    },
  ]);

  useEffect(() => {
    checkIsReferee();
  }, []);

  const handleClick = (item) => {
    if (item.dialog) {
      setOpenDialog(item.dialog);
    } else if (item.route) {
      navigate(item.route);
    }
  };

  const checkIsReferee = async () => {
    try {
      const response = await isReferee();
      if (response.status === 200) {
        setMenuItems((prevItems) => [
          ...prevItems,
          {
            icon: "/images/hubble/icons/judge.svg",
            text: "داوری اثر",
            route: "/hubble/UploadsArbitration",
          },
        ]);
      }
      setLoading(false);
    } catch (err) {
      // errorHandler(err);
      setLoading(false);
    }
  };

  return (
    <HuubleCard>
      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Loading />
        </div>
      ) : (
        <div className="row justify-items-between">
          {menuItems.map((item, index) => {
            return (
              <div
                onClick={() => handleClick(item)}
                key={index}
                className={`col-3 ${classes.listItemContainer}}]`}
              >
                <div className={classes.listItem}>
                  <div className={classes.listItemIcon}>
                    <img src={item.icon} />
                  </div>
                  <p>{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <AwardsDialog
        open={openDialog === "awards"}
        onClose={() => setOpenDialog(null)}
      />
      <IntroduceDialog
        open={openDialog === "introduce"}
        onClose={() => setOpenDialog(null)}
      />
      <RegulationDialog
        open={openDialog === "requlation"}
        onClose={() => setOpenDialog(null)}
      />
    </HuubleCard>
  );
};

export default HubbleDashboardMenu;
